var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 21.75H6C1.59 21.75 0.25 20.41 0.25 16V6C0.25 1.59 1.59 0.25 6 0.25H7.5C9.25 0.25 9.8 0.82 10.5 1.75L12 3.75C12.33 4.19 12.38 4.25 13 4.25H16C20.41 4.25 21.75 5.59 21.75 10V16C21.75 20.41 20.41 21.75 16 21.75ZM6 1.75C2.42 1.75 1.75 2.43 1.75 6V16C1.75 19.57 2.42 20.25 6 20.25H16C19.58 20.25 20.25 19.57 20.25 16V10C20.25 6.43 19.58 5.75 16 5.75H13C11.72 5.75 11.3 5.31 10.8 4.65L9.3 2.65C8.78 1.96 8.62 1.75 7.5 1.75H6Z",
    fill: "#713FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 6.13C18.59 6.13 18.25 5.79 18.25 5.38V4C18.25 2.42 17.58 1.75 16 1.75H7C6.59 1.75 6.25 1.41 6.25 1C6.25 0.59 6.59 0.25 7 0.25H16C18.42 0.25 19.75 1.58 19.75 4V5.38C19.75 5.79 19.41 6.13 19 6.13Z",
    fill: "#713FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder2);
export default __webpack_public_path__ + "static/media/folder_2.7b591a5b.svg";
export { ForwardRef as ReactComponent };